<template>
  <div>
    <b-jumbotron>
      <b-container>
        <div class="text-center" v-if="loading"><b-spinner></b-spinner></div>
        <b-row class="mb-5" v-else>
          <div class="col">
            <h1>Languages</h1>
          </div>
        </b-row>
        <hr />

        <b-row class="mt-5">
          <b-col>
            <h5>Language</h5>
            <b-form-select v-model="selectedLanguage">
              <b-form-select-option
                v-for="language in languages"
                :key="language.english_name"
                :value="language.code"
              >
                {{ language.english_name }}
              </b-form-select-option>
            </b-form-select>
          </b-col>
          <b-col>
            <h5>Options</h5>
            <b-button variant="primary" class="mr-1" @click="enable">
              Enable
            </b-button>
            <b-button variant="danger" @click="disable">
              Disable
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-jumbotron>
  </div>
</template>

<script>
import $api from '@/services/api';

export default {
  data() {
    return {
      languages: null,
      selectedLanguage: 'en',
      loading: true,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.loading = true;
      $api.get('/v1/internal/languages').then((languages) => {
        this.languages = languages;
      });
      this.loading = false;
    },
    enable() {
      this.save('enable');
    },
    disable() {
      this.save('disable');
    },
    async save(endpoint) {
      this.loading = true;
      const response = await $api.put(`/v1/internal/languages/${endpoint}/${this.selectedLanguage}`);
      this.loading = false;
      // eslint-disable-next-line no-alert
      alert(response);
    },
  },
};
</script>